import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { RegistrationData } from '../types/password';

export const useCreatePasswordForm = () => {
  const createPasswordSchema = yup
    .object({
      oldPassword: yup
        .string()
        .required()
        .min(10)
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.{10,})/),
      password: yup
        .string()
        .required()
        .min(10)
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.{10,})/),
    })
    .required();

  const {
    register,
    watch,
    getValues,
    setValue,
    handleSubmit,
    clearErrors,
    setError,
    formState: { errors },
  } = useForm<RegistrationData>({
    resolver: yupResolver(createPasswordSchema),
  });

  return {
    register,
    watch,
    getValues,
    setValue,
    errors,
    handleSubmit,
    clearErrors,
    setError,
  };
};
